/* CT Mini Reviews: crossfade rotation for blocks/ct-mini-reviews.liquid.
   Pauses on hover/focus, offscreen, in the theme editor, and under
   prefers-reduced-motion. Swipe steps manually; optional dash pagination. */

if (!customElements.get('ct-mini-reviews')) {
  customElements.define(
    'ct-mini-reviews',
    class CtMiniReviews extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.ct-mini-review'));
        if (!this.slides.length) return;
        this.index = 0;
        this.paused = new Set();
        this.duration = (parseFloat(this.dataset.duration) || 5) * 1000;
        this.autoplay =
          this.dataset.autoplay === 'true' &&
          this.slides.length > 1 &&
          !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        const dotsEl = this.querySelector('[data-mini-dots]');
        this.dots = dotsEl
          ? this.slides.map((_, i) => {
              const dot = document.createElement('button');
              dot.type = 'button';
              dot.className = 'ct-mini-reviews__dot';
              dot.setAttribute('aria-label', 'Review ' + (i + 1) + ' of ' + this.slides.length);
              dot.addEventListener('click', () => this.show(i));
              dotsEl.append(dot);
              return dot;
            })
          : [];

        this.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse') this.pause('hover');
        });
        this.addEventListener('pointerleave', (event) => {
          if (event.pointerType === 'mouse') this.resume('hover');
        });
        this.addEventListener('focusin', () => this.pause('focus'));
        this.addEventListener('focusout', () => this.resume('focus'));

        new IntersectionObserver(
          (entries) => (entries[0].isIntersecting ? this.resume('offscreen') : this.pause('offscreen')),
          { threshold: 0.3 }
        ).observe(this);

        this.addEventListener('touchstart', (e) => (this.touchX = e.changedTouches[0].clientX), { passive: true });
        this.addEventListener(
          'touchend',
          (e) => {
            const dx = e.changedTouches[0].clientX - this.touchX;
            if (Math.abs(dx) >= 48) this.step(dx < 0 ? 1 : -1);
          },
          { passive: true }
        );

        if (window.Shopify && Shopify.designMode) {
          document.addEventListener('shopify:block:select', (e) => {
            const slide = e.target.closest('.ct-mini-review');
            if (!slide || !this.slides.includes(slide)) return;
            this.pause('editor');
            this.show(this.slides.indexOf(slide));
          });
          document.addEventListener('shopify:block:deselect', () => this.resume('editor'));
        }

        this.show(0);
        this.start();
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      start() {
        clearInterval(this.timer);
        if (!this.autoplay) return;
        this.timer = setInterval(() => {
          if (!this.paused.size) this.step(1);
        }, this.duration);
      }

      pause(reason) {
        this.paused.add(reason);
      }

      resume(reason) {
        this.paused.delete(reason);
      }

      step(direction) {
        if (this.slides.length < 2) return;
        this.show((this.index + direction + this.slides.length) % this.slides.length);
      }

      show(index) {
        this.index = index;
        this.slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === index);
          slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        });
        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      }
    }
  );
}
